<!-- component.html -->
<div class="container">
  <!-- Bouton hamburger (visible mobile uniquement) -->
  <button class="menu-toggle"
          [class.open]="menuOpen()"
          (click)="toggleMenu()"
          aria-label="Toggle video menu">
    <span class="icon">
      @if (menuOpen()) {
        ✕
      } @else {
        ☰
      }
    </span>
    @if (playList().length > 0 && !menuOpen()) {
      <span class="video-count">{{ playList().length }}</span>
    }
  </button>

  <!-- Overlay pour fermer le menu (mobile) -->
  <div class="sidebar-overlay"
       [class.open]="menuOpen()"
       (click)="closeMenu()"></div>

  <!-- Sidebar -->
  <aside class="sidebar" [class.open]="menuOpen()">
    <!-- Header du menu (mobile uniquement) -->
    <div class="sidebar-header">
      <h3>{{ 'support.videos' | translate }} ({{ playList().length }})</h3>
      <button class="close-btn"
              (click)="closeMenu()"
              aria-label="Close menu">
        ✕
      </button>
    </div>

    <div class="video-list">
      @if (playList().length === 0) {
        <div class="no-data">{{ 'support.no_video' | translate }}</div>
      } @else {
        @for (video of playList(); track video) {
          <a (click)="playVideo(video)"
             [class.active]="selectedVideo() === getCleanVideoName(video)">
            {{ video.replace('.mp4', '') }}
          </a>
        }
      }
    </div>
  </aside>

  <!-- Player -->
  <main class="player-container">
    @if (selectedVideo()) {
      <div class="player">
        <video #videoPlayer
               [src]="selectedVideoUrl()"
               controls
               autoplay
               class="video-player">
          {{ 'support.browser_no_support' | translate }}
        </video>
        <div class="player-info">
          <h2>{{ selectedVideo()!.replace('.mp4', '') }}</h2>
        </div>
      </div>
    } @else {
      <div class="empty-player">
        <p>{{ 'support.select_video' | translate }}</p>
      </div>
    }
  </main>
</div>
